module.exports = "/images/pattern.png?184778a869d3f31fe3ad27dafa4c7bd2";